// @flow
//export const PROD_URL = 'https://world-insight:preview@dev.world-insight.de';
// export const PROD_URL = 'https://dev.world-insight.de';
export const DEV_URL = 'https://dev.world-insight.de';
export const PROD_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : 'https://manager.world-insight.de';

let LOCAL_URL = 'http://localhost:3000';

if (process.env.NODE_ENV === 'development') {
  try {
    const env = require('./../.env.local.js');
    if (env) {
      LOCAL_URL = env.API_HOST;
      console.info(
        "[ENV SETUP]: Found '.env.local.js' using it for API_HOST Setup."
      );
    }
  } catch (err) {
    // env not defined
    console.warn(
      "[ENV SETUP]: No '.env.local.js' found in your src Directory. Please see README.md File for more Information. Using Default Config with API_HOST=http://localhost:3000"
    );
  }
}

export const API_URL =
  (process.env.NODE_ENV === 'development' ? LOCAL_URL : PROD_URL) +
  '/api/digital';
export const BASE_URL =
  process.env.NODE_ENV === 'development' ? LOCAL_URL : PROD_URL;
export const TOKEN = 'WI_TOKEN';

export const STATIC_ROUTES_PATHS = {
  voyages_detail: '/v2/voyages/',
  voyage_dates: '/v2/upload_an_einem_termin',
  voyage_bookings: '/v2/upload_an_einer_buchung',
  voyage_courses: '/v2/reiseverlauf',
  voyage_content: '/v2/voyage_content',
  super_admin_voyage_infos_templates: '/v2/super_admin_voyage_infos_templates',
  super_admin_voyage_infos: '/v2/super_admin_voyage_infos',
  crud: '/v2/crud',
  crud_edit: '/v2/crud/edit'
};

export const DOCUMENT_TYPES_TITLES_SHORT = {
  Reiseinformationen: 'R',
  Visuminformationen: 'Vi',
  Visumantrag: 'Va',
  WeitereDokumente: 'W',
  VisumGruppen: 'V(G)',
  Ausreisebesttigung: 'A',
  EinladungVisumandereLnder: 'E',
  Flugticket: 'Ft',
  Flugdaten: 'Fd',
  Reiseplan: 'Rp',
  RailFly: 'DB'
};

export const TRENNER_CONST = 'Trenner';
export const REISETAG_CONST = 'Reisetag';

export const AIRBRAKE_PROJECT_KEY = '96e071f174d7f19ae52c771901a6376d';
export const AIRBRAKE_PROJECT_ID = '202618';

export const LOCATION_STATE_CRUDSAVE = {
  showBackButton: true,
  saveButton: {
    event: 'CRUD_save'
  },
  saveAndBackButton: {
    event: 'CRUD_save_and_back'
  }
};
export const LOCATION_STATE_CRUDSAVE_WITH_DRAFT = {
  showBackButton: true,
  saveButton: {
    event: 'CRUD_save'
  },
  saveAndBackButton: {
    event: 'CRUD_save_and_back'
  },
  saveAndPublishButton: {
    event: 'CRUD_save_and_publish'
  },
  discardButton: {
    event: 'CRUD_discard'
  }
};
export const LOCATION_STATE_CRUDSAVE_WITH_PUBLISH = {
  showBackButton: true,
  saveButton: {
    event: 'CRUD_save'
  },
  saveAndBackButton: {
    event: 'CRUD_save_and_back'
  },
  saveAndPublishButton: {
    event: 'CRUD_save_and_publish'
  }
};

export const LOCATION_STATE_CRUD_ARCHIVE = {
  showBackButton: true
};

export const LOCATION_STATE_VOYAGECONTENT_SAVE = {
  showBackButton: true,
  saveButton: {
    event: 'voyage_content_save'
  },
  saveAndPublishButton: {
    event: 'voyage_content_save_and_publish'
  }
};

export const LOCATION_STATE_VOYAGECONTENT_SAVE_AND_DISCARD = {
  showBackButton: true,
  saveButton: {
    event: 'voyage_content_save'
  },
  saveAndPublishButton: {
    event: 'voyage_content_save_and_publish'
  },
  discardButton: {
    event: 'voyage_content_discard'
  }
};

export const LOCATION_STATE_VOYAGEINFOTEMPLATE_SAVE = {
  showBackButton: true,
  saveButton: {
    event: 'voyage_info_template_save'
  },
  saveAndPublishButton: {
    event: 'voyage_info_template_save_and_publish'
  },
  discardButton: null
};

export const LOCATION_STATE_VOYAGEINFOTEMPLATE_SAVE_DISCARD = {
  showBackButton: true,
  saveButton: {
    event: 'voyage_info_template_save'
  },
  saveAndPublishButton: {
    event: 'voyage_info_template_save_and_publish'
  },
  discardButton: {
    event: 'voyage_info_template_discard'
  }
};

export const LOCATION_STATE_VOYAGECOURSESAVE = {
  showBackButton: true,
  saveButton: {
    event: 'voyage_course_save'
  }
};
export const LOCATION_STATE_DOCUMENTMODULEASSIGNMENT_SAVE = {
  showBackButton: true,
  saveButton: {
    event: 'document_module_assignment_save'
  }
};
export const DOCUMENT_TITLE_BASE = 'WORLD INSIGHT';



// WEBPACK FOOTER //
// ./src/utils/Constants.js